import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

import {
  PaginateVehiclesActions,
  PaginateVehiclesState,
} from "store/ducks/settings/vehicles";

import { SelectedFilterActions, SelectedFilterState } from "store/ducks/filter";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridVehicles, FilterVehicles } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListVehicles: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('vehicles');

  const { data, loading, pagination } = useSelector<
    RootStateOrAny,
    PaginateVehiclesState
  >((state) => state.paginateVehicles);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configurações")} <MenuSelector page="vehicles" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertVehicle") && (
            <S.ButtonMini onClick={() => history.push("/settings/vehicle/new")}>
              {getTranslation("novoVeiculo")}
            </S.ButtonMini>
          )}
          <FilterVehicles />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridVehicles vehicles={data} />
        <Paginator
          pagination={pagination}
          settingsPage='vehicles'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
